<template>
  <a-modal
    :title="title"
    :width="modalWidth"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="language['common.cancel']"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item v-if="usernameShow"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['user.column.userName']">
          <a-input type="text" v-model="username" :placeholder="language['common.pleaseInput']+language['user.column.userName']" v-decorator="[ 'username', validatorRules.username]"  />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['column.oldPassword']">
          <a-input-password type="password" :placeholder="language['warning.oldPasswordRequired']" v-decorator="[ 'oldpassword', validatorRules.oldpassword]" :maxLength="maxLength" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['column.newPassword']">
          <a-input-password type="password" :placeholder="language['warning.newPasswordRequired']" v-decorator="[ 'password', validatorRules.password]" :maxLength="maxLength" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="language['column.confirmNewPassword']">
          <a-input-password type="password" @blur="handleConfirmBlur" :placeholder="language['warning.confirmNewPasswordRequired']" v-decorator="[ 'confirmpassword', validatorRules.confirmpassword]" :maxLength="maxLength" />
        </a-form-item>

      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { putAction,getAction } from '@/api/manage'
  import {mapActions} from "vuex";

  export default {
    name: "UserPassword",
    data () {
      return {
        disabledPassworld:[],
        disabledPassworldStr:'',
        title:this.$store.getters.language["portal.ui2.changePassword"],
        maxLength: 40,
        modalWidth:800,
        visible: false,
        confirmLoading: false,
        /*validatorRules:{
          oldpassword:{
            rules: [{
              required: true, message: this.$store.getters.language["warning.oldPasswordRequired"],
            }],
          },
          password:{
            rules: [
              { required: true, message: this.$store.getters.language["warning.newPasswordRequired"], },
              { pattern: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{8,40}$/, message: this.$store.getters.language['warning.passwordConsists'] },
              { validator: this.validateToNextPassword, }
            ],
          },
          confirmpassword:{
            rules: [
              { required: true, message: this.$store.getters.language['warning.confirmNewPasswordRequired'], },
              { validator: this.compareToFirstPassword, }
            ],
          }
        },*/
        confirmDirty:false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        form:this.$form.createForm(this),
        url: "sys/user/updatePassword",
        username:"",
        usernameShow:false,
      }
    },
    created () {
      getAction("/sys/dictItem/queryPlatformBlackPassword").then(res=> {
        if (res.success) {
          let list = res.result;
          this.disabledPassworld = list
          this.disabledPassworldStr = list.map(item => item.value.trim()).join(', ')
        }
      })
    },
    computed:{
      language() {
        return this.$store.getters.language
      },
      validatorRules(){
        return {
          username:{
            rules: [{
              required: true, message: this.$store.getters.language['common.pleaseInput']+this.$store.getters.language['user.column.userName'],
            }],
          },
          oldpassword:{
            rules: [{
              required: true, message: this.$store.getters.language["warning.oldPasswordRequired"],
            }],
          },
          password:{
            rules: [{
              required: true,
              pattern:/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,}$/,
              message: this.$store.getters.language['warning.passwordConsists'].replace("${passwordDisabled}", this.disabledPassworldStr)
            }, {
              validator: this.validateToNextPassword,
            }],
          },
          confirmpassword:{
            rules: [{
              required: true, message: this.$store.getters.language['warning.inputpasswordAgain'],
            }, {
              validator: this.compareToFirstPassword,
            }],
          },
        }
      }
    },
    methods: {
      show(uname){
        /*if(!uname){
          this.$message.warning(this.language["common.noLoggedUserMessage"]);
          return
        }else{
          this.username = uname
          this.form.resetFields();
          this.visible = true;
        }*/
        if(!!uname){
          this.username = uname
        }
        this.form.resetFields();
        this.visible = true;
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
        this.selectedRole = [];
      },
      ...mapActions(["Logout"]),
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let params = Object.assign({username:this.username},values)
            console.log("修改密码提交数据",params)
            putAction(this.url,params).then((res)=>{
              if(res.success){
                console.log(res)
                that.$message.success(res.message);
                that.close();
                that.Logout({}).then(() => {
                  that.$router.push({ path: '/user/login' });
                  window.location.reload()
                }).catch(err => {
                  that.$message.error({
                    title: this.language['portal.front.errors'],
                    description: err.message
                  })
                })
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      validateToNextPassword  (rule, value, callback) {
        const form = this.form;
        if(value && value === form.getFieldValue('oldpassword')){
          callback(this.language['portal.front.password.not.same']);
        }else{
          if (value && this.confirmDirty) {
            form.validateFields(['confirm'], { force: true })
          }
          if(!!this.disabledPassworld&&this.disabledPassworld.length>0&&value.match(/^(?=.*[a-zA-Z])(?=.*\d)(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,./]).{12,}$/)){
            for(var i=0;i<this.disabledPassworld.length;i++){
              let item = this.disabledPassworld[i];
              if(value.includes(item.value.trim())){
                callback(this.$store.getters.language['warning.passwordConsists'].replace("${passwordDisabled}", this.disabledPassworldStr));
              }
            }
          }
          callback();
        }
      },
      compareToFirstPassword  (rule, value, callback) {
        const form = this.form;
        if (value && value !== form.getFieldValue('password')) {
          callback(this.language['warning.passwordEnteredTwiceDifferent']);
        }else if(value && value === form.getFieldValue('oldpassword')){
          callback(this.language['portal.front.password.not.same']);
        } else {
          callback()
        }
      },
      handleConfirmBlur  (e) {
        const value = e.target.value
        this.confirmDirty = this.confirmDirty || !!value
      }

    }
  }
</script>

<style scoped>

</style>

